import { nanoid } from 'nanoid';
import moment from 'moment';

// 格式化时间到天
export function formatDateToDay(time: any) {
  return moment(time).format('YYYY-MM-DD');
}

// 格式化时间到秒
export function formatDateToSecond(time: any, defaultValue = '--') {
  return time ? moment(time).format('YYYY年MM月DD日 HH:mm:ss') : defaultValue;
  // 可以通过utc来调整时差
  // monent(myDate).utcOffset(0).format('YYYY/MM/DD HH:mm:ss');
  // monent(myDate).utc(0).format('YYYY/MM/DD HH:mm:ss');
}

export function uuid(len = 21) {
  return nanoid(len);
}

/**
 * 数字左边补零
 *
 * @export
 * @param {number} num
 * @return {*}
 */
export function pad(num: number) {
  return num < 10 ? `0${num}` : num;
}

/**
 * 时间格式化
 * 输入为秒
 * 输出为字符串
 *
 * @export
 * @param {number} time
 * @return {*}
 */
export function formatTime(time: number) {
  const second = time % 60;
  const minute = ((time - second) / 60) % 60;
  const hour = ((time - second) / 60 - minute) / 60;
  return `${pad(hour)}:${pad(minute)}:${pad(second)}`;
}

/**
 * 数字转大写字母
 *
 * @param {number} index
 * @return {*}
 */
export function numberToLetter(index: number) {
  return String.fromCharCode(index + 65);
}

/**
 * 大写字母转数字
 *
 * @export
 * @param {string} letter
 * @return {*}
 */
export function letterToNumber(letter: string) {
  return letter.charCodeAt(0) - 65;
}
